module.exports = __webpack_public_path__ + "img/doors_open.3a7f6fff.svg";